import React, { Component, Fragment } from 'react'
import { Link} from 'react-router-dom'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import DashboardIcon from '@material-ui/icons/Dashboard'
import PeopleIcon from '@material-ui/icons/People'
import BarChartIcon from '@material-ui/icons/BarChart'
import ScheduleIcon from '@material-ui/icons/Schedule'
import FitnessCenterIcon from '@material-ui/icons/FitnessCenter'
import NutritionIcon from '@material-ui/icons/Restaurant'
import { MenuList, MenuItem, Typography } from '@material-ui/core'
import Tooltip from '@material-ui/core/Tooltip';

export class MenuLeftTrainer extends Component {
  render() {
    const {linkColor, pathname }= this.props
    return (
      <Fragment>
      <MenuList style={linkColor}>
       
       <MenuItem component={Link}  to='/dashboard' selected={'/dashboard' === pathname}>
           <ListItemIcon style={linkColor}>
             <Tooltip title="Dashboard">
               <DashboardIcon /> 
             </Tooltip>
           </ListItemIcon>

           <ListItemText primary={<Typography  style={ linkColor }>Dashboard</Typography>}  />
       </MenuItem>
      
       <MenuItem component={Link} to='/scheduler' selected={'/scheduler' === pathname}>
           <ListItemIcon style={linkColor}>
           <Tooltip title="Scheduler">
             <ScheduleIcon />
             </Tooltip>
           </ListItemIcon>
           <ListItemText primary={<Typography  style={ linkColor }>Scheduler</Typography>} />
       </MenuItem>
       <MenuItem component={Link} to='/allclients' selected={'/allclients' === pathname}>
         <ListItemIcon style={linkColor}>
         <Tooltip title="Clients">
           <PeopleIcon />
           </Tooltip>
         </ListItemIcon>
        
         <ListItemText primary={<Typography  style={ linkColor}>Clients</Typography>} />
       </MenuItem>
     
       <MenuItem component={Link} to='/workout' selected={'/workout' === pathname}>
         <ListItemIcon style={linkColor}>
         <Tooltip title="Workout">
           <FitnessCenterIcon />
           </Tooltip>
         </ListItemIcon>
         <ListItemText primary={<Typography  style={ linkColor }>Workout</Typography>} />
       </MenuItem>
       <MenuItem component={Link} to='/nutrition' selected={'/nutrition' === pathname}>
         <ListItemIcon style={linkColor}>
         <Tooltip title="Nutrition">
           <NutritionIcon />
           </Tooltip>
         </ListItemIcon>
         <ListItemText primary={<Typography  style={ linkColor }>Nutrition</Typography>} />
       </MenuItem>
       
       <MenuItem component={Link} to='/trainers' selected={'/trainers' === pathname}>
         <ListItemIcon style={linkColor}>
         <Tooltip title="Trainers">
           <PeopleIcon />
           </Tooltip>
         </ListItemIcon>
         <ListItemText primary={<Typography  style={ linkColor }>Trainers </Typography>} />
       </MenuItem>

       <MenuItem>
         <ListItemIcon style={linkColor}>
            <BarChartIcon />
         </ListItemIcon>
         
         <ListItemText primary={<Typography  style={ linkColor }>Raports</Typography>} />
       </MenuItem>
   </MenuList>
      </Fragment>
    )
  }
}

export default MenuLeftTrainer
